import styled from "styled-components";

export const NotificationsContainer = styled.div`
  padding: 0;
`;

export const NotificationsHeader = styled.div`
  margin-bottom: 16px;
`;

export const FilterWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-left: auto;

  .btn-filter {
    height: 37px;
    width: 166px;
  }

  .btn-export {
    height: 37px;
    width: 166px;
    margin: auto;
  }

  .btn-clear-filters {
    height: 37px;
    width: 166px;
    margin: auto;
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  background: var(--color-contrast-white);
  border-radius: 6px;
  border: 1px solid var(--color-neutral-200, #e5e7eb);
  overflow: hidden;

  .notifications-description {
    white-space: normal !important;
    word-break: break-word;
  }
`;

export const EmptyState = styled.div`
  
  padding: 32px 16px;
  background: var(--color-contrast-white);
  border: 1px solid var(--color-neutral-200, #e5e7eb);
  border-radius: 6px;
  text-align: center;
  color: var(--color-neutral-500, #6b7280);
  font-size: 14px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;
